import { CountryModel } from '../ts/interfaces/models/CountryModel';
import { BaseService } from './baseService';

class CountryService extends BaseService<CountryModel> {
  controllerName = 'countries';
}

export const countryService = new CountryService();
